import React from 'react'
import {Icon} from '@chakra-ui/react'

const ManualsIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M3.73315 12V3.99996C3.73315 3.64634 3.87363 3.3072 4.12368 3.05715C4.37373 2.8071 4.71287 2.66663 5.06649 2.66663H11.7332C11.8746 2.66663 12.0103 2.72282 12.1103 2.82284C12.2103 2.92286 12.2665 3.05851 12.2665 3.19996V12.8C12.2665 12.9414 12.2103 13.0771 12.1103 13.1771C12.0103 13.2771 11.8746 13.3333 11.7332 13.3333H5.06649C4.71287 13.3333 4.37373 13.1928 4.12368 12.9428C3.87363 12.6927 3.73315 12.3536 3.73315 12ZM3.73315 12C3.73315 11.6463 3.87363 11.3072 4.12368 11.0571C4.37373 10.8071 4.71287 10.6666 5.06649 10.6666H12.2665"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default ManualsIcon
